export default __webpack_public_path__ + "static/markedwax-19eaf4a85be78c2b7937fb53e8c62db5.png";